import { defineMessages } from 'react-intl';

export default defineMessages({
  sorry: {
    id: 'src.pages.FatalityPopUp.sorry',
    defaultMessage: "We're sorry",
  },
  callIfYouPrefer: {
    id: 'src.pages.FatalityPopUp.callIfYouPrefer',
    defaultMessage: "We know this can be difficult. If you'd prefer to speak with a Claims team member, please call us - we're here for you. Otherwise, you can continue your claim online.",
  },
  continue: {
    id: 'src.pages.FatalityPopUp.continue',
    defaultMessage: 'Continue',
  },
  callUs: {
    id: 'src.pages.FatalityPopUp.callUs',
    defaultMessage: 'Call us at ',
  },
});
